import type { EventStructure } from "../types";

export function attachPersonaDescription(event: EventStructure) {
  // const event = window.helium.finalResponse as EventStructure;
  // Initialize response format
  let result = { string: "", words: { 1: "", 2: "", 3: "" } };

  if (!event.demographic) {
    console.log(event);
    return event;
  }

  // Step 1: Infer Device & Technical Quality
  if (
    event.persona.attributes.deviceModelTier === "1" ||
    (event.persona.attributes.GPUTier === 3 &&
      event.persona.attributes.internetSpeedCategory === "High" &&
      (!event.persona.attributes.screenResolution?.width ||
        event.persona.attributes.screenResolution.width >= 1080))
  ) {
    result.words[1] = "High-Tech";
  } else if (
    event.persona.attributes.deviceModelTier === "3" ||
    (event.persona.attributes.GPUTier === 2 &&
      event.persona.attributes.internetSpeedCategory === "Moderate" &&
      (!event.persona.attributes.screenResolution?.width ||
        event.persona.attributes.screenResolution?.width < 1080) &&
      (!event.persona.attributes.screenResolution?.width ||
        event.persona.attributes.screenResolution?.width >= 720))
  ) {
    result.words[1] = "Mid-Range";
  } else if (
    ["4", "5"].includes(event.persona.attributes.deviceModelTier) ||
    (event.persona.attributes.GPUTier === 1 &&
      event.persona.attributes.internetSpeedCategory === "Low" &&
      (!event.persona.attributes.screenResolution?.width ||
        event.persona.attributes.screenResolution.width < 720))
  ) {
    result.words[1] = "Low-Tech";
  } else if (
    event.persona.attributes.VPNDetected ||
    event.persona.attributes.TORUsageDetected ||
    event.persona.attributes.incognitoMode ||
    event.persona.attributes.adBlockerDetected
  ) {
    result.words[1] = "Privacy-Focused";
  } else if (
    event.persona.attributes.platform === "mobile" &&
    event.behavior.attributes.interactionCount === "High"
  ) {
    result.words[1] = "Mobile-Centric";
  } else if (
    event.persona.attributes.platform === "web" &&
    event.behavior.attributes.interactionCount === "High"
  ) {
    result.words[1] = "Desktop-Centric";
  }

  // Step 2: Infer Location & Cultural Factors
  if (["Tier 1", "Tier 2"].includes(event.persona.attributes.cityTier)) {
    result.words[2] = "Urban";
  } else if (
    ["Tier 2", "Tier 3"].includes(event.persona.attributes.cityTier) &&
    event.persona.attributes.urbanDensity === "Medium"
  ) {
    result.words[2] = "Suburban";
  } else if (
    event.persona.attributes.cityTier === "Tier 3" &&
    event.persona.attributes.urbanDensity === "Low"
  ) {
    result.words[2] = "Rural";
  } else if (
    false
    // event.persona.attributes.language?.primaryLanguage !==
    //   event.meta.siteLanguage ||
    // event.persona.attributes.countryName !== event.meta.siteCountry
  ) {
    result.words[2] = "International";
  } else if (
    false
    // event.persona.attributes.countryName === event.meta.siteCountry &&
    // event.persona.attributes.primaryLanguage === event.meta.siteLanguage &&
    // event.persona.attributes.preferredCurrency === event.meta.localCurrency
  ) {
    result.words[2] = "Local";
  } else if (
    false
    // event.meta.visit_date in event.meta.holidayPeriods
    // && event.behavior.attributes.sessionDepth > 3
  ) {
    result.words[2] = "Seasonal";
  }

  // Step 3: Infer Socio-Demographic Trait
  if (
    ["18-24", "25-34"].includes(event.demographic.age) &&
    ["Student", "Entry-level professional", "Freelancer"].includes(
      event.demographic.occupation,
    )
  ) {
    result.words[3] = "Young Adult";
  } else if (
    ["35-44", "45-54"].includes(event.demographic.age) &&
    ["Mid-level professional", "Senior professional", "Executive"].includes(
      event.demographic.occupation,
    )
  ) {
    result.words[3] = "Mid-Career";
  } else if (
    ["55-64", "65+"].includes(event.demographic.age) &&
    ["Retired", "Executive"].includes(event.demographic.occupation)
  ) {
    result.words[3] = "Senior";
  } else if (
    ["Married", "In a relationship"].includes(
      event.demographic.marital_status,
    ) &&
    !["No children"].includes(event.demographic.family_structure)
  ) {
    result.words[3] = "Family-Oriented";
  } else if (
    event.demographic.marital_status === "Single" &&
    event.demographic.family_structure === "No children"
  ) {
    result.words[3] = "Single Independent";
  } else if (
    ["Mid-level professional", "Senior professional", "Executive"].includes(
      event.demographic.occupation,
    )
    // &&
    // event.behavior.attributes.motivation === "Career growth"
  ) {
    result.words[3] = "Career-Driven";
  } else if (
    false &&
    event.behavior.attributes.lifestyle === "Active" &&
    ["Fitness", "Outdoor activities"].includes(
      event.behavior.attributes.hobbiesInterests,
    )
  ) {
    result.words[3] = "Active Lifestyle";
  } else if (
    false &&
    event.behavior.attributes.lifestyle === "Sedentary" &&
    event.behavior.attributes.motivation === "Home-oriented"
  ) {
    result.words[3] = "Sedentary Lifestyle";
  } else if (
    ["$60,000 - $79,999", "$80,000 - $99,999"].includes(
      event.demographic.income_level,
    )
    // &&
    // event.behavior.attributes.attitude === "Price-Sensitive"
  ) {
    result.words[3] = "Value-Seeker";
  } else if (
    ["$100,000 - $149,999", "$150,000+"].includes(
      event.demographic.income_level,
    )
    // &&
    // event.behavior.attributes.attitude === "High-Spender"
  ) {
    result.words[3] = "Affluent";
  } else if (
    // event.behavior.attributes.attitude === "Price-Sensitive" &&
    event.ecommerce.attributes.maxPreferredPriceRange === "Low"
  ) {
    result.words[3] = "Price-Sensitive";
  } else if (
    // event.behavior.attributes.personalityTraits === "Tech-savvy" &&
    ["1", "2"].includes(event.persona.attributes.deviceModelTier)
  ) {
    result.words[3] = "Tech-Savvy";
  } else if (
    false &&
    event.behavior.attributes.personalityTraits === "Traditionalist" &&
    event.behavior.attributes.motivation !== "Innovation"
  ) {
    result.words[3] = "Traditionalist";
  } else if (
    event.persona.attributes.VPNDetected ||
    event.persona.attributes.incognitoMode ||
    event.persona.attributes.TORUsageDetected
  ) {
    result.words[3] = "Privacy-Conscious";
  }

  // Final combined demographic string
  result.string =
    `${result.words[1].trim()} ${result.words[2].trim()} ${result.words[3].trim()}`.trim();

  event.sessionDescription.demographic = result.string;

  return event;
}
